// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"447":"component-lazy","741":"side-panel-card-lazy"}[chunkId] || chunkId) + "." + {"447":"7d7f67eeb57dcf38846d","741":"27bda3d9b26fb48b58bf","819":"6e6e21950607f74135a2"}[chunkId] + ".js";
};